module.exports = {"230111001":"呼兰街道","230111002":"兰河街道","230111003":"腰堡街道","230111004":"利民街道","230111005":"康金街道","230111006":"双井街道","230111007":"建设路街道","230111008":"学院路街道","230111009":"长岭街道","230111010":"沈家街道","230111011":"南京路街道","230111012":"裕民街道","230111013":"裕田街道","230111014":"裕强街道","230111015":"萧乡街道","230111016":"公园路街道","230111105":"二八镇","230111106":"石人镇","230111107":"白奎镇","230111109":"方台镇","230111110":"莲花镇","230111111":"大用镇","230111114":"利业镇","230111201":"杨林乡","230111203":"许堡乡","230111205":"孟家乡","230111579":"呼兰农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230111.json
// module id = 767
// module chunks = 0